export default "__VITE_ASSET__joDMr6L8ND$mWl_mh_lu1w__"